import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-image-checker',
  templateUrl: './image-checker.component.html',
  styleUrls: ['./image-checker.component.scss'],
})
export class ImageCheckerComponent implements OnChanges {
  @Input() imageBase64 = '';
  @Input() tileBase64 = '';
  @Input() tileY = 0;
  @Input() tileW = 55;
  @Input() tileH = 52;
  @Input() width = 300;
  @Input() height = 240;
  @Output() positionChange = new EventEmitter<number>();
  /** 松手时发射，用于触发自动验证 */
  @Output() dragEnd = new EventEmitter<number>();

  tileX = 0;
  dragging = false;

  /** 滑块可拖动的最大 x */
  get maxX(): number {
    return this.width - this.tileW;
  }

  /** 滑块把手 left 偏移 —— 使把手中心与拼图块中心对齐 */
  get thumbLeft(): number {
    const thumbW = 44;
    return this.tileX + (this.tileW - thumbW) / 2;
  }

  private dragStartClientX = 0;
  private dragStartTileX = 0;

  ngOnChanges(changes: SimpleChanges): void {
    this.reset();
  }

  reset() {
    this.tileX = 0;
    this.positionChange.emit(this.tileX);
  }

  /* ========== Mouse ========== */
  onMouseDown(evt: MouseEvent) {
    this.dragStartClientX = evt.clientX;
    this.dragStartTileX = this.tileX;
    this.dragging = true;
    evt.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(evt: MouseEvent) {
    if (!this.dragging) return;
    this.updatePosition(evt.clientX);
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    if (!this.dragging) return;
    this.dragging = false;
    this.dragEnd.emit(this.tileX);
  }

  /* ========== Touch ========== */
  onTouchStart(evt: TouchEvent) {
    if (!evt.touches.length) return;
    this.dragStartClientX = evt.touches[0].clientX;
    this.dragStartTileX = this.tileX;
    this.dragging = true;
    evt.preventDefault();
  }

  @HostListener('document:touchmove', ['$event'])
  onTouchMove(evt: TouchEvent) {
    if (!this.dragging || !evt.touches.length) return;
    this.updatePosition(evt.touches[0].clientX);
  }

  @HostListener('document:touchend')
  onTouchEnd() {
    if (!this.dragging) return;
    this.dragging = false;
    this.dragEnd.emit(this.tileX);
  }

  /* ========== Helpers ========== */
  private updatePosition(clientX: number) {
    const delta = clientX - this.dragStartClientX;
    let x = this.dragStartTileX + delta;
    x = Math.max(0, Math.min(this.maxX, Math.round(x)));
    if (x !== this.tileX) {
      this.tileX = x;
      this.positionChange.emit(this.tileX);
    }
  }
}
